import dayjs from 'utils/date-helper';
import { Color } from '@joinforma/ui/constants/themes';
import { ICompany, IEmployee } from 'hooks/useQueryProfile';

declare global {
  interface Window {
    Intercom?: (action: string, config: unknown) => void;
  }
}

export const initIntercom = (employee: IEmployee, company: ICompany) => {
  if (window.Intercom) {
    window.Intercom('boot', {
      app_id: 'y2wzhv2s',
      email: employee.email,
      name: employee.preferred_first_name || employee.full_name,
      user_id: employee.id,
      company_id: company.id,
      user_hash: employee.hmac,
      action_color: Color.INDIGO,
      background_color: Color.INDIGO,
      created_at: dayjs(employee.created).valueOf(),
      isp_url: `https://internal.joinforma.com/employees/${employee.id}/claims`,
      company: {
        id: company.id,
        name: company.company_info.common_name,
        upgraded_at: dayjs(employee.created).valueOf(),
      },
    });
  }
};
